import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleAssignCostProfileToResourceRequest(
  state: State,
  {
    costProfile,
    resource,
  }: Boundaries["assignCostProfileToResource"]["request"],
): State {
  const index = state.findIndex(
    (req) =>
      req.costProfile.uuid === costProfile.uuid &&
      req.resource.uuid === resource.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { costProfile, resource, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        { costProfile, resource, request: setRequestStateToPending() },
      ];
}

function handleAssignCostProfileToResourceSuccess(
  state: State,
  {
    costProfile,
    resource,
  }: Boundaries["assignCostProfileToResource"]["success"],
): State {
  const index = state.findIndex(
    (req) =>
      req.costProfile.uuid === costProfile.uuid &&
      req.resource.uuid === resource.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { costProfile, resource, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        { costProfile, resource, request: setRequestStateToSuccess() },
      ];
}

function handleAssignCostProfileToResourceFailure(
  state: State,
  {
    costProfile,
    resource,
  }: Boundaries["assignCostProfileToResource"]["request"],
): State {
  const index = state.findIndex(
    (req) =>
      req.costProfile.uuid === costProfile.uuid &&
      req.resource.uuid === resource.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { costProfile, resource, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        { costProfile, resource, request: setRequestStateToFailure() },
      ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.assignCostProfileToResourceRequested]:
      handleAssignCostProfileToResourceRequest,
    [events.assignCostProfileToResourceSucceeded]:
      handleAssignCostProfileToResourceSuccess,
    [events.assignCostProfileToResourceFailed]:
      handleAssignCostProfileToResourceFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
